import React from 'react';
import { useRef, useEffect, useState, useContext } from 'react';
import { Cartcontext } from '../../context/Context';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import './Header.css';

import ConversionsAPI from '../Helper/ConversionsAPI';
import CartTop from '../CartTop/CartTop';
import myAxios from '../AxiosHeader';
import { URL } from '../AxiosUrlGlobal';
import TrafficSource from '../../action/TrafficSource';

function Navbar() {
    const location = useLocation();
    const navigate = useNavigate();
    const navRef = useRef();
    const dropdownRef = useRef();
    const dropdownContentRef = useRef();

    const [loadCategory, setLoadCategory] = useState(true);
    const [product, setProduct] = useState([]);
    const [zeroCategory, setZeroCategory] = useState(false);
    const [loading, setLoading] = useState(true);
    const [navBgColor, setNavBgColor] = useState('');
    const [headerTextColor, setHeaderTextColor] = useState('');
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024); // Check if mobile view
    const [expanded, setExpanded] = useState(null); // State to track expanded category
    const [moreExpanded, setMoreExpanded] = useState(null);
    const [mobileExpanded, setMobileExpanded] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to track dropdown open/close

    const Globalstate = useContext(Cartcontext);
    const { storeData, ipAddress } = Globalstate;

    TrafficSource();
    ConversionsAPI({ EventType: 'PageViewEvent', ip: ipAddress });

    useEffect(() => {
        ReactPixel.pageView();
        ReactGA.send({
            hitType: 'pageview',
            page: location.pathname,
            title: location.pathname,
        });

        TagManager.dataLayer({
            dataLayer: {
                event: 'pageview',
                pagePath: location.pathname,
            },
        });

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [location.pathname]);

    const showNavbar = () => {
        MobileDropIconClick(null);
        navRef.current.classList.toggle('responsive_nav');
        setNavBgColor(
            storeData
                ? storeData.color.HeaderColor
                : 'rgba(187, 168, 157, 0.09)'
        );
    };

    useEffect(() => {
        if (product.length === 0 && !loadCategory) {
            setZeroCategory(true);
        }
    }, [loadCategory]);

    useEffect(() => {
        myAxios
            .get(`${URL}/e-category`)
            .then((res) => {
                setProduct(res.data);
                setLoadCategory(false);
            })
            .catch((err) => console.log(err));
    }, []);

    useEffect(() => {
        if (storeData && storeData.suspended) {
            navigate('/suspend');
        }
    }, [location.pathname, storeData, navigate]);

    useEffect(() => {
        if (!localStorage.getItem('ecomId')) {
            localStorage.setItem('ecomId', generateRandomId());
        }
    }, []);

    useEffect(() => {
        if (storeData && storeData.color) {
            setLoading(false);
            setHeaderTextColor(storeData.color.HeaderTextColor || '#000000');
        }
    }, [storeData]);

    function generateRandomId() {
        const characters =
            'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let randomId = '';
        for (let i = 0; i < 50; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            randomId += characters.charAt(randomIndex);
        }
        return randomId;
    }

    const truncateText = (text, maxLength) => {
        return text.length > maxLength
            ? text.substring(0, maxLength) + '.'
            : text;
    };

    const headerStyle =
        storeData && storeData.color
            ? {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: '55px',
                  padding: '0px 6px 0px 0px',
                  color: headerTextColor,
                  background: storeData.color.HeaderColor,
                  transition: 'opacity 0.3s ease-in-out',
                  opacity: loading ? 0 : 1,
              }
            : {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  height: '55px',
                  padding: '0px 6px 0px 0px',
                  background: 'rgba(187, 168, 157, 0.09)',
                  transition: 'opacity 0.3s ease-in-out',
                  opacity: loading ? 0 : 1,
              };

    const sortedProducts = product.sort((a, b) => {
        return b.subcategories.length - a.subcategories.length;
    });

    const regularItems = sortedProducts.slice(0, 4);
    const moreItems = sortedProducts.slice(4);

    const toggleDropdown = (e) => {
        MoreDropIconClick(!moreExpanded);
        setIsDropdownOpen(!isDropdownOpen);
        setExpanded(null); // Close the expanded category
        e.stopPropagation(); // Prevents triggering the document click listener
        dropdownContentRef.current.classList.toggle('show');
    };

    const handleClickOutside = (event) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
        ) {
            dropdownContentRef.current.classList.remove('show');
            setIsDropdownOpen(false); // Close the dropdown when clicking outside
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleMenuItemClick = (link) => {
        dropdownContentRef.current.classList.remove('show');
        setIsDropdownOpen(false); // Close the dropdown
        navigate(link);
    };

    const handleIconClick = (index) => {
        setExpanded(expanded === index ? null : index); // Toggle the expanded state
    };

    const MoreDropIconClick = (index) => {
        setMoreExpanded(moreExpanded === index ? null : index); // Toggle the expanded state
    };
    const MobileDropIconClick = (index) => {
        setMobileExpanded(mobileExpanded === index ? null : index); // Toggle the expanded state
    };

    const onMouse = (e) => {
        e.currentTarget.style.backgroundColor =
            storeData.color?.HeaderHoverColor || '#1e90ff';

        e.currentTarget.style.color =
            storeData.color?.HeaderHoverTextColor || 'white';
    };
    const leaveMouse = (e) => {
        e.currentTarget.style.backgroundColor = storeData.color?.HeaderColor;
        e.currentTarget.style.color = headerTextColor;
    };

    return (
        <>
            <CartTop />
            <header style={headerStyle}>
                <Link
                    to={'/'}
                    style={{ textDecoration: 'none', color: headerTextColor }}
                >
                    {storeData?.logo ? (
                        <div className="logoMain">
                            <img
                                className="h-logo"
                                src={storeData ? storeData.logo : ''}
                                alt={storeData ? storeData.store : ''}
                            />
                        </div>
                    ) : (
                        <h2
                            className="h-logo"
                            style={{
                                color: headerTextColor,
                                fontFamily: 'initial',
                            }}
                        >
                            {storeData.store}
                        </h2>
                    )}
                </Link>
                <nav ref={navRef} style={{ background: navBgColor }}>
                    {zeroCategory && <div>No menu found..</div>}
                    {isMobile
                        ? sortedProducts.map((data, mainIndex) => {
                              if (data.subcategories.length > 0) {
                                  return (
                                      <React.Fragment key={`fragment-main-${mainIndex}`}>
                                          <div key={`main-${mainIndex}`}>
                                              <a
                                                  onClick={() => {
                                                      showNavbar();
                                                      navigate(
                                                          `/view-category/${data.id}`
                                                      );
                                                  }}
                                                  style={{
                                                      color: headerTextColor,
                                                  }}
                                              >
                                                  {truncateText(data.name, 20)}
                                              </a>
                                              <KeyboardArrowDownIcon
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() =>
                                                      MobileDropIconClick(
                                                          mainIndex
                                                      )
                                                  }
                                              />
                                          </div>

                                          {data.subcategories.map(
                                              (sub, index) => (
                                                  <div
                                                      key={`sub-${mainIndex}-${index}`}
                                                      style={{
                                                          display:
                                                              mobileExpanded ===
                                                              mainIndex
                                                                  ? 'flex'
                                                                  : 'none',
                                                          flexDirection:
                                                              'column',
                                                          cursor: 'pointer',
                                                          fontSize: '14px',
                                                          padding: '1px',
                                                      }}
                                                      onClick={() => {
                                                          showNavbar();
                                                          navigate(
                                                              `/view-category/${sub._id}/sub`
                                                          );
                                                      }}
                                                  >
                                                      <div
                                                          style={{
                                                              border: 'none',
                                                          }}
                                                      >
                                                          <SubdirectoryArrowRightIcon fontSize="12px" />
                                                          <h4>
                                                              {truncateText(
                                                                  sub.name,
                                                                  20
                                                              )}
                                                          </h4>
                                                      </div>
                                                  </div>
                                              )
                                          )}
                                      </React.Fragment>
                                  );
                              } else {
                                  return (
                                      <div key={`main-${data.id}`}>
                                          <a
                                              onClick={() => {
                                                  showNavbar();
                                                  navigate(
                                                      `/view-category/${data.id}`
                                                  );
                                              }}
                                              style={{ color: headerTextColor }}
                                          >
                                              {truncateText(data.name, 20)}
                                          </a>
                                      </div>
                                  );
                              }
                          })
                        : regularItems.map((data, index) => {
                              if (data.subcategories.length > 0) {
                                  return (
                                      <div key={`regular-${index}`}>
                                          <div style={{ padding: '6px' }}>
                                              <a
                                                  onClick={() => {
                                                      navigate(
                                                          `/view-category/${data.id}`
                                                      );
                                                  }}
                                                  style={{
                                                      color: headerTextColor,
                                                      margin: '0px 0px 0px 7px',
                                                      padding: '0px',
                                                      fontSize: '18px',
                                                      letterSpacing: '2px',
                                                      fontWeight: 'normal',
                                                  }}
                                              >
                                                  {truncateText(data.name, 20)}
                                              </a>
                                              {expanded === index ? (
                                                  <KeyboardArrowUpIcon
                                                      style={{
                                                          color: headerTextColor,
                                                          fontSize: '22px',
                                                          cursor: 'pointer',
                                                      }}
                                                      onClick={() =>
                                                          handleIconClick(index)
                                                      }
                                                  />
                                              ) : (
                                                  <KeyboardArrowDownIcon
                                                      style={{
                                                          color: headerTextColor,
                                                          fontSize: '22px',
                                                          cursor: 'pointer',
                                                      }}
                                                      onClick={() =>
                                                          handleIconClick(index)
                                                      }
                                                  />
                                              )}
                                          </div>
                                          <div
                                              style={{
                                                  display:
                                                      expanded === index
                                                          ? 'block'
                                                          : 'none',
                                                  position: 'absolute',
                                                  minWidth: '190px',
                                                  background:
                                                      storeData.color
                                                          ?.HeaderColor,
                                                  color: headerTextColor,
                                                  top: '60px',
                                                  zIndex: '9999',
                                                  overflow: 'hidden',
                                                  boxShadow:
                                                      '0px 8px 16px 0px rgba(0,0,0,0.2)',
                                                  borderRadius: '5px',
                                              }}
                                          >
                                              {data.subcategories.map(
                                                  (sub, index) => (
                                                      <div key={`sub-regular-${index}`}>
                                                          <a
                                                              onClick={() => {
                                                                  handleIconClick(
                                                                      null
                                                                  );
                                                                  navigate(
                                                                      `/view-category/${sub._id}/sub`
                                                                  );
                                                              }}
                                                              style={{
                                                                  width: '100%',
                                                                  backgroundColor:
                                                                      storeData
                                                                          .color
                                                                          ?.HeaderColor,
                                                                  margin: '0px',
                                                                  padding:
                                                                      '15px',
                                                                  color: headerTextColor,
                                                                  textDecoration:
                                                                      'none',
                                                                  cursor: 'pointer',
                                                                  textTransform:
                                                                      'uppercase',
                                                                  fontSize:
                                                                      '14px',
                                                                  borderBottom:
                                                                      '1px solid rgba(204, 204, 204, 0.16)',
                                                              }}
                                                              onMouseEnter={
                                                                  onMouse
                                                              }
                                                              onMouseLeave={
                                                                  leaveMouse
                                                              }
                                                          >
                                                              {truncateText(
                                                                  sub.name,
                                                                  20
                                                              )}
                                                          </a>
                                                      </div>
                                                  )
                                              )}
                                          </div>
                                          |{' '}
                                      </div>
                                  );
                              } else {
                                  return (
                                      <div key={`regular-${data.id}`}>
                                          <a
                                              onClick={() => {
                                                  showNavbar();
                                                  navigate(
                                                      `/view-category/${data.id}`
                                                  );
                                              }}
                                              style={{
                                                  color: headerTextColor,
                                                  margin: '10px',
                                                  fontSize: '18px',
                                                  letterSpacing: '2px',
                                                  fontWeight: 'normal',
                                              }}
                                          >
                                              {truncateText(data.name, 20)}
                                          </a>
                                          |{' '}
                                      </div>
                                  );
                              }
                          })}

                    {!isMobile && moreItems.length > 0 && (
                        <div className="dropdown" ref={dropdownRef}>
                            <a
                                className="dropbtn"
                                style={{
                                    color: headerTextColor,
                                    display: 'flex',
                                    alignItems: 'center',
                                    margin: '10px',
                                    fontSize: '18px',
                                    letterSpacing: '2px',
                                    fontWeight: 'normal',
                                }}
                                onClick={toggleDropdown}
                            >
                                MORE
                                {isDropdownOpen ? (
                                    <KeyboardArrowUpIcon
                                        style={{
                                            color: headerTextColor,
                                            fontSize: '22px',
                                            cursor: 'pointer',
                                        }}
                                    />
                                ) : (
                                    <KeyboardArrowDownIcon
                                        style={{
                                            color: headerTextColor,
                                            fontSize: '22px',
                                            cursor: 'pointer',
                                        }}
                                    />
                                )}
                            </a>
                            <div
                                className="dropdown-content"
                                ref={dropdownContentRef}
                                style={{
                                    background: storeData.color?.HeaderColor,
                                    borderRadius: '5px',
                                }}
                            >
                                {moreItems.map((data, index) => {
                                    if (data.subcategories.length > 0) {
                                        return (
                                            <div
                                                style={{
                                                    width: '100%',
                                                    margin: '0px',
                                                    cursor: 'pointer',
                                                    borderBottom:
                                                        '1px solid rgba(204, 204, 204, 0.16)',
                                                }}
                                                key={index}
                                                onMouseEnter={onMouse}
                                                onMouseLeave={leaveMouse}
                                            >
                                                <a
                                                    onClick={() => {
                                                        MoreDropIconClick(
                                                            index
                                                        );
                                                        handleMenuItemClick(
                                                            `/view-category/${data.id}`
                                                        );
                                                    }}
                                                    style={{
                                                        color: headerTextColor,
                                                    }}
                                                    onMouseEnter={onMouse}
                                                    onMouseLeave={leaveMouse}
                                                >
                                                    {truncateText(
                                                        data.name,
                                                        20
                                                    )}
                                                </a>

                                                <KeyboardArrowDownIcon
                                                    style={{
                                                        color: headerTextColor,
                                                        fontSize: '20px',
                                                        width: '50px',
                                                        cursor: 'pointer',
                                                        margin: '0px 0px 0px 0px',
                                                    }}
                                                    onClick={() =>
                                                        MoreDropIconClick(index)
                                                    }
                                                />
                                                <div
                                                    style={{
                                                        display:
                                                            moreExpanded ===
                                                            index
                                                                ? 'block'
                                                                : 'none',
                                                        position: 'absolute',
                                                        minWidth: '190px',
                                                        background:
                                                            storeData.color
                                                                ?.HeaderColor,
                                                        color: headerTextColor,
                                                        left: '-197px',
                                                        top: '0px',
                                                        zIndex: '9999',
                                                        overflow: 'hidden',
                                                        boxShadow:
                                                            '0px 8px 16px 0px rgba(0,0,0,0.2)',
                                                        borderRadius: '5px',
                                                    }}
                                                >
                                                    {data.subcategories.map(
                                                        (sub, index) => (
                                                            <div
                                                                key={index}
                                                                onClick={
                                                                    toggleDropdown
                                                                }
                                                            >
                                                                <a
                                                                    style={{
                                                                        borderBottom:
                                                                            '1px solid rgba(204, 204, 204, 0.16)',
                                                                    }}
                                                                    onMouseEnter={
                                                                        onMouse
                                                                    }
                                                                    onMouseLeave={
                                                                        leaveMouse
                                                                    }
                                                                    onClick={() => {
                                                                        navigate(
                                                                            `/view-category/${sub._id}/sub`
                                                                        );
                                                                    }}
                                                                >
                                                                    {truncateText(
                                                                        sub.name,
                                                                        20
                                                                    )}
                                                                </a>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div key={index}>
                                                <a
                                                    onClick={() =>
                                                        handleMenuItemClick(
                                                            `/view-category/${data.id}`
                                                        )
                                                    }
                                                    style={{
                                                        color: headerTextColor,
                                                        borderBottom:
                                                            '1px solid rgba(204, 204, 204, 0.16)',
                                                    }}
                                                    onMouseEnter={onMouse}
                                                    onMouseLeave={leaveMouse}
                                                >
                                                    {truncateText(
                                                        data.name,
                                                        20
                                                    )}
                                                </a>
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        </div>
                    )}

                    <button
                        className="nav-btn nav-close-btn"
                        onClick={showNavbar}
                    >
                        <FaTimes style={{ color: headerTextColor }} />
                    </button>
                </nav>
                <button className="nav-btn" onClick={showNavbar}>
                    <FaBars style={{ color: headerTextColor }} />
                </button>
            </header>
        </>
    );
}

export default Navbar;
